<div class="ss-side-menu__backdrop" (click)="closeMobileDrawer()" aria-hidden="true"></div>
<aside class="ss-side-menu" [class.is-docked]="isDocked" aria-label="Navegação principal">
  <div class="ss-side-menu__top">
    <a class="ss-side-menu__brand" [routerLink]="appRoutes.events.list()" aria-label="SpotPass">
      <span class="ss-side-menu__logo-full" aria-hidden="true"></span>
      <svg class="ss-side-menu__logo-mark" width="30" height="34" viewBox="144 14 70 81" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M206.437 47.1134V44.7773C206.437 42.9853 204.984 41.532 203.192 41.532H191.753C189.961 41.532 188.508 42.9853 188.508 44.7773V68.9907C188.508 72.0534 187.862 74.2067 186.57 75.448C185.278 76.6934 183.102 77.3147 180.041 77.3147H172.722C169.66 77.3147 167.507 76.6934 166.265 75.448C165.021 74.2067 164.4 72.0534 164.4 68.9907V43.7347C164.4 40.6734 165.021 38.5213 166.265 37.276C167.507 36.0347 169.66 35.4107 172.722 35.4107H179.141C180.934 35.4107 182.386 33.9587 182.386 32.1654V23.0147C182.386 21.2227 180.934 19.7694 179.141 19.7694H169.996C162.437 19.7694 156.601 21.7787 152.488 25.796C148.375 29.8147 146.317 35.604 146.317 43.16V69.5654C146.317 77.124 148.375 82.9107 152.488 86.928C156.601 90.9467 162.437 92.956 169.996 92.956H182.768C190.229 92.956 196.042 90.924 200.202 86.8574C204.365 82.792 206.447 77.028 206.447 69.5654V47.1534L206.437 47.1134" fill="currentColor"/>
        <path d="M206.129 35.5453C208.487 35.5453 210.097 33.116 209.151 30.9574C207.828 27.944 206.028 25.3227 203.745 23.092C200.752 20.1667 197.093 18.0587 192.784 16.7507C190.652 16.104 188.484 17.6467 188.484 19.8747V32.2667C188.484 34.0774 189.952 35.5453 191.761 35.5453H206.129" fill="currentColor"/>
      </svg>
    </a>
    <button
      type="button"
      class="ss-side-menu__mobile-close"
      aria-label="Fechar menu"
      (click)="closeMobileDrawer()">
      <lucide-icon name="x" [size]="18" [strokeWidth]="2.4" aria-hidden="true"></lucide-icon>
    </button>
  </div>

  <div class="ss-side-menu__panel">
    <div class="ss-side-menu__modules">
      <ng-container *ngFor="let item of navItems; let last = last;">
        <div
          class="ss-side-menu__group"
          ssToggleSubmenu
          *ngIf="showMenuItem(item).length > 0"
          [class.is-open]="isModuleActive(item)">
          <button
            type="button"
            class="ss-side-menu__item"
            [ngClass]="{'no-border': last}"
            [attr.data-tooltip-label]="item.name"
            [attr.aria-expanded]="isModuleActive(item) ? 'true' : 'false'">
            <span class="ss-side-menu__icon">
              <lucide-icon [name]="item.icon" [size]="17" aria-hidden="true"></lucide-icon>
            </span>
            <span class="ss-side-menu__text">{{ item.name }}</span>
            <span class="ss-side-menu__chevron" aria-hidden="true">
              <lucide-icon name="chevron-down" [size]="14" [strokeWidth]="2.2"></lucide-icon>
            </span>
          </button>

          <div class="ss-side-submenu" [class.is-open]="isModuleActive(item)">
            <a
              *ngFor="let subitem of showMenuItem(item)"
              [routerLink]="[subitem.url]"
              class="ss-side-submenu__item"
              [attr.data-tooltip-label]="subitem.name"
              [attr.aria-current]="currentSubmenu == subitem.url ? 'page' : 'false'"
              [ngClass]="{'teste': currentSubmenu == subitem.url}">
              <span class="ss-side-submenu__icon">
                <lucide-icon [name]="subitem.icon" [size]="16" aria-hidden="true"></lucide-icon>
              </span>
              <span class="ss-side-submenu__text">{{ subitem.name }}</span>
            </a>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="ss-side-menu__footer">
      <button
        type="button"
        id="shrink-menu"
        class="ss-side-menu__item ss-side-menu__shrink"
        aria-label="Reduzir menu"
        data-tooltip-label="Reduzir menu"
        ssShrinkMenu>
        <span class="ss-side-menu__shrink-icon" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="3"></rect>
            <path d="M9 3v18M16 10l-2 2 2 2"></path>
          </svg>
        </span>
        <span class="ss-side-menu__shrink-verb">Reduzir</span>
        <span class="ss-side-menu__shrink-noun">menu</span>
      </button>
      <a
        class="ss-side-menu__item ss-side-menu__help"
        [href]="helpCenterUrl"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Central de ajuda"
        data-tooltip-label="Central de ajuda">
        <span class="ss-side-menu__help-icon" aria-hidden="true">
          <lucide-icon name="circle-question-mark" [size]="17" [strokeWidth]="2"></lucide-icon>
        </span>
        <span class="ss-side-menu__text">Central de ajuda</span>
        <lucide-icon class="ss-side-menu__external" name="external-link" [size]="13" aria-hidden="true"></lucide-icon>
      </a>
    </div>
  </div>
</aside>
